import axios, { AxiosInstance } from "axios";
import { AccountInfo } from "./resources/AccountInfo";
import { Addresses } from "./resources/Addresses";
import { AuditLogs } from "./resources/AuditLogs";
import { Autofill } from "./resources/Autofill";
import { Checks } from "./resources/Checks";
import { Clients } from "./resources/Clients";
import { Documents } from "./resources/Documents";
import { Flow } from "./resources/Flow";
import { LivePhotos } from "./resources/LivePhotos";
import { LiveVideos } from "./resources/LiveVideos";
import { Lookups } from "./resources/Lookups";
import { Reports } from "./resources/Reports";
import { RiskProfiles } from "./resources/RiskProfile";
import { Static } from "./resources/Static";
import { TeamMembers } from "./resources/TeamMembers";
import { Tokens } from "./resources/Tokens";
import { Webhooks } from "./resources/Webhooks";
import { WorkflowSessions } from "./resources/WorkflowSessions";

const baseURL = "https://api.complycube.com/v1";

export type ComplyCubeOptions = {
  apiKey: string;
};

export class ComplyCube {
  public readonly axiosInstance: AxiosInstance;

  public readonly client: Clients;
  public readonly document: Documents;
  public readonly livePhoto: LivePhotos;
  public readonly liveVideo: LiveVideos;
  public readonly check: Checks;
  public readonly workflowSession: WorkflowSessions;
  public readonly report: Reports;
  public readonly address: Addresses;
  public readonly flow: Flow;
  public readonly riskProfile: RiskProfiles;
  public readonly webhook: Webhooks;
  public readonly auditLog: AuditLogs;
  public readonly token: Tokens;
  public readonly teamMember: TeamMembers;
  public readonly static: Static;
  public readonly autofill: Autofill;
  public readonly lookup: Lookups;
  public readonly accountInfo: AccountInfo;

  constructor({ apiKey }: ComplyCubeOptions) {
    if (!apiKey) {
      throw new Error("No apiKey provided");
    }

    this.axiosInstance = axios.create({
      baseURL,
      headers: {
        Authorization: apiKey,
        "Content-Type": "application/json",
        "User-Agent": "complycube-nodejs/1.1.13"
      }
    });

    this.client = new Clients(this.axiosInstance);
    this.document = new Documents(this.axiosInstance);
    this.livePhoto = new LivePhotos(this.axiosInstance);
    this.liveVideo = new LiveVideos(this.axiosInstance);
    this.check = new Checks(this.axiosInstance);
    this.workflowSession = new WorkflowSessions(this.axiosInstance);
    this.report = new Reports(this.axiosInstance);
    this.address = new Addresses(this.axiosInstance);
    this.riskProfile = new RiskProfiles(this.axiosInstance);
    this.webhook = new Webhooks(this.axiosInstance);
    this.auditLog = new AuditLogs(this.axiosInstance);
    this.token = new Tokens(this.axiosInstance);
    this.teamMember = new TeamMembers(this.axiosInstance);
    this.flow = new Flow(this.axiosInstance);
    this.static = new Static(this.axiosInstance);
    this.lookup = new Lookups(this.axiosInstance);
    this.autofill = new Autofill(this.axiosInstance);
    this.accountInfo = new AccountInfo(this.axiosInstance);
  }
}
